// Confira seu pedido: itens, sugestões e Avançar (verbatim; etapas via agruparEtapas).
// Só o TOTEM passa por aqui: desde 29/09/2026 o Balcão vai do Finalizar direto
// para "Como deseja consumir?" (carrinho e sugestões ficam na lateral).
import { ArrowLeft, ImageOff, Minus, Plus, ShoppingCart, Trash2 } from "lucide-react";
import { fmt, getImageUrl } from "../lib/helpers";

import { AvisoOfertasCliente } from "../../ofertas-do-dia";
import { agruparEtapas } from "../lib/agruparEtapas";

export default function TelaConferencia({ ctx }) {
  const { setScreen, telaCls, products, allProductsForPhotos, cart, removeFromCart, updateCartQty, cartTotal, getItemStepsSummary, getSuggestedProducts, addSuggestionToCart, chipCliente, ofertasCliente } = ctx;
  return (
    <div className={`${telaCls} bg-zinc-950 flex flex-col select-none`}>
      <div className="bg-zinc-900 border-b border-zinc-800 px-4 py-4 flex items-center gap-3">
        <button onClick={() => setScreen("menu")} className="w-10 h-10 rounded-full bg-zinc-800 hover:bg-zinc-700 flex items-center justify-center"><ArrowLeft className="w-5 h-5 text-zinc-300" /></button>
        <h2 className="text-xl font-bold text-zinc-100 flex-1">Confira seu Pedido</h2>
        {chipCliente()}
      </div>
      <div className="flex-1 overflow-y-auto px-6 py-6 max-w-2xl mx-auto w-full">
        <AvisoOfertasCliente ofertasDia={ofertasCliente} cart={cart} className="mb-3 text-zinc-100" />
        <div className="space-y-3">
          {cart.map((item) => {
            const cid = item.cartItemId || item.id;
            const allProds = allProductsForPhotos.length > 0 ? allProductsForPhotos : products;
            const groupedSteps = agruparEtapas(item, allProds, getItemStepsSummary);
            return (
              <div key={cid} className="bg-zinc-800 rounded-xl p-4 flex flex-col gap-3">
                <div className="flex gap-4">
                  <div className="w-20 h-20 rounded-lg overflow-hidden flex-shrink-0 bg-zinc-700">
                    {item.photo_url ? <img src={getImageUrl(item.photo_url)} alt={item.name} className="w-full h-full object-cover" /> : <div className="w-full h-full flex items-center justify-center"><ImageOff className="w-6 h-6 text-zinc-500" /></div>}
                  </div>
                  <div className="flex-1 min-w-0">
                    <div className="flex items-start justify-between gap-2">
                      <div className="min-w-0">
                        <p className="text-base font-semibold text-zinc-100 leading-tight">{item.name}</p>
                        {item.combo_type && <span className="text-xs bg-orange-500/20 text-orange-400 px-2 py-0.5 rounded font-medium uppercase mt-0.5 inline-block">{item.combo_type}</span>}
                      </div>
                      <button onClick={() => removeFromCart(cid)} className="p-1.5 text-zinc-500 hover:text-red-400 flex-shrink-0"><Trash2 className="w-5 h-5" /></button>
                    </div>
                    {item.observation && <p className="text-xs text-zinc-500 mt-1 italic break-words">📝 {item.observation}</p>}
                    <div className="flex items-center justify-between mt-2">
                      <div className="flex items-center gap-3">
                        {!item.etiqueta_balanca && <button onClick={() => updateCartQty(cid, -1)} className="w-9 h-9 rounded-full bg-zinc-700 hover:bg-zinc-600 flex items-center justify-center"><Minus className="w-4 h-4 text-zinc-300" /></button>}
                        <span className="text-lg font-bold text-zinc-100 min-w-[1.5rem] text-center">{item.is_divisible || !Number.isInteger(item.quantity) ? item.quantity.toFixed(3).replace('.', ',') : item.quantity}{item.sale_unit && item.sale_unit !== "un" ? <span className="text-xs font-normal text-zinc-400 ml-0.5">{item.sale_unit}</span> : null}</span>
                        {!item.etiqueta_balanca && <button onClick={() => updateCartQty(cid, 1)} className="w-9 h-9 rounded-full bg-orange-500 hover:bg-orange-600 flex items-center justify-center"><Plus className="w-4 h-4 text-white" /></button>}
                      </div>
                      <span className="text-lg font-bold text-orange-500">R$ {fmt((item.final_price || item.sale_price) * item.quantity)}</span>
                    </div>
                  </div>
                </div>
                {/* Subitens agrupados por etapa */}
                {groupedSteps.length > 0 && (
                  <div className="space-y-2 pl-1 border-t border-zinc-700/50 pt-3">
                    {groupedSteps.map((step, gi) => (
                      <div key={gi}>
                        <p className="text-[10px] font-semibold text-zinc-500 uppercase tracking-wide mb-1.5">{step.stepName}</p>
                        <div className="space-y-1.5">
                          {step.items.map((si, i) => (
                            <div key={i} className="flex items-center gap-2">
                              {si.photo_url && (
                                <div className="w-8 h-8 rounded-md bg-zinc-700 flex-shrink-0 overflow-hidden">
                                  <img
                                    src={getImageUrl(si.photo_url)}
                                    alt=""
                                    className="w-full h-full object-cover"
                                    onError={(e) => { e.currentTarget.parentElement.style.display = 'none'; }}
                                  />
                                </div>
                              )}
                              <div className="flex-1 min-w-0">
                                <p className="text-xs text-zinc-300 truncate leading-tight">
                                  {si.qty > 1 && <span className="text-zinc-500 mr-0.5">{si.qty}×</span>}
                                  {si.name}
                                </p>
                                {si.price != null && si.price > 0 && (
                                  <p className="text-[11px] text-orange-500 font-medium leading-tight">R$ {si.price.toFixed(2).replace('.', ',')}</p>
                                )}
                              </div>
                            </div>
                          ))}
                        </div>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            );
          })}
        </div>
        {/* Suggested products */}
        {cart.length > 0 && getSuggestedProducts.length > 0 && (
          <div className="mt-6">
            <h3 className="text-base font-bold text-zinc-300 mb-3">Que tal adicionar?</h3>
            <div className="flex gap-3 overflow-x-auto pb-2 scrollbar-hide">
              {getSuggestedProducts.map((p) => (
                <button key={p.id} onClick={() => addSuggestionToCart(p)} className="flex-shrink-0 w-32 bg-zinc-800 rounded-xl border border-zinc-700 hover:border-orange-500/50 overflow-hidden transition-all active:scale-95">
                  <div className="w-full h-24 bg-zinc-700">
                    {p.photo_url ? <img src={getImageUrl(p.photo_url)} alt={p.name} className="w-full h-full object-cover" onError={(e) => { e.target.style.display = 'none'; }} /> : <div className="w-full h-full flex items-center justify-center"><ImageOff className="w-6 h-6 text-zinc-500" /></div>}
                  </div>
                  <div className="p-2">
                    <p className="text-xs font-semibold text-zinc-200 line-clamp-2 leading-tight">{p.name}</p>
                    <div className="flex items-center justify-between mt-1">
                      <span className="text-xs font-bold text-orange-500">R$ {fmt(p.sale_price)}</span>
                      <Plus className="w-4 h-4 text-orange-500" />
                    </div>
                  </div>
                </button>
              ))}
            </div>
          </div>
        )}
        {cart.length === 0 && (
          <div className="flex flex-col items-center justify-center h-64 text-zinc-400"><ShoppingCart className="w-16 h-16 mb-4" /><p className="text-xl">Carrinho vazio</p><button onClick={() => setScreen("menu")} className="mt-4 px-6 py-3 bg-zinc-800 hover:bg-zinc-700 text-zinc-300 rounded-xl">Voltar ao Cardápio</button></div>
        )}
      </div>
      {cart.length > 0 && (
        <div className="bg-zinc-900 border-t border-zinc-800 px-6 py-4">
          <div className="flex justify-between items-center mb-4 max-w-2xl mx-auto"><span className="text-lg text-zinc-400">Total</span><span className="text-3xl font-black text-orange-500">R$ {fmt(cartTotal)}</span></div>
          <div className="flex gap-3 max-w-2xl mx-auto">
            <button onClick={() => setScreen("menu")} data-e2e="conferencia-adicionar" className="flex-1 h-14 rounded-xl bg-zinc-800 hover:bg-zinc-700 text-zinc-300 font-bold text-lg transition-all flex items-center justify-center gap-2">Adicionar mais</button>
            <button onClick={() => setScreen("delivery_type")} data-e2e="conferencia-avancar" className="flex-1 h-14 rounded-xl bg-orange-500 hover:bg-orange-600 text-white font-bold text-lg transition-all shadow-lg active:scale-95 flex items-center justify-center gap-2">Avançar</button>
          </div>
        </div>
      )}
    </div>
  );
}
